import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useCreatePayable } from "../../api/payables";
import { useToast } from "../../components/ToastProvider";

export function NewPayableModal({ show, onClose }: { show: boolean; onClose: () => void }) {
  const [supplierName, setSupplierName] = useState("");
  const [category, setCategory] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [value, setValue] = useState("");
  const [error, setError] = useState<string | null>(null);

  const create = useCreatePayable();
  const toast = useToast();

  function reset() {
    setSupplierName("");
    setCategory("");
    setDueDate("");
    setValue("");
    setError(null);
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!supplierName.trim()) return setError("Informe o fornecedor.");
    if (!category.trim()) return setError("Informe a categoria.");
    if (!dueDate) return setError("Informe o vencimento.");
    const numericValue = Number(value.replace(",", "."));
    if (!numericValue || numericValue <= 0) return setError("Informe um valor válido.");

    try {
      await create.mutateAsync({ supplierName, category, dueDate, value: numericValue });
      toast("Conta a pagar cadastrada.");
      reset();
      onClose();
    } catch {
      setError("Não foi possível cadastrar a conta.");
    }
  }

  return (
    <Modal backdrop="static" keyboard={false} show={show} onHide={onClose} centered className="nt-dialog">
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title style={{ fontSize: 20, fontFamily: "var(--font-heading)" }}>Nova conta a pagar</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column gap-3">
          <div>
            <label className="form-label" style={{ fontSize: 12 }}>
              Fornecedor
            </label>
            <input className="form-control" value={supplierName} onChange={(e) => setSupplierName(e.target.value)} placeholder="Ex.: AWS América do Sul" />
          </div>
          <div>
            <label className="form-label" style={{ fontSize: 12 }}>
              Categoria
            </label>
            <input className="form-control" value={category} onChange={(e) => setCategory(e.target.value)} placeholder="Ex.: Infraestrutura" />
          </div>
          <div className="row g-3">
            <div className="col-12 col-sm-6">
              <label className="form-label" style={{ fontSize: 12 }}>
                Vencimento
              </label>
              <input type="date" className="form-control" value={dueDate} onChange={(e) => setDueDate(e.target.value)} />
            </div>
            <div className="col-12 col-sm-6">
              <label className="form-label" style={{ fontSize: 12 }}>
                Valor (R$)
              </label>
              <input className="form-control" value={value} onChange={(e) => setValue(e.target.value)} placeholder="0,00" />
            </div>
          </div>
          {error && (
            <div className="text-danger" style={{ fontSize: 12.5 }}>
              {error}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-danger" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" className="btn btn-success" disabled={create.isPending}>
            Cadastrar
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
